// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import reportApi from '~/apis/report';
import {
  GET_REPORT_AVERAGE_JOB,
  GET_REPORT_JOB_DISTRIBUTION,
  GET_REPORT_PURCHASE_ORDER_TOTAL,
  GET_REPORT_SALE_BY_CITY,
  GET_REPORT_SERVICE_VOLUME,
} from '~/utils/constants/actionType';
import { IJobDistributionItemRes, IQueryParamReport } from '~/utils/interface/report';

export const getReportServiceVolume = createAsyncThunk(
  GET_REPORT_SERVICE_VOLUME,
  async (payload: IQueryParamReport, { rejectWithValue }) => {
    try {
      const resp = await reportApi.getServiceVolume(payload);
      return resp?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportAverageJob = createAsyncThunk(
  GET_REPORT_AVERAGE_JOB,
  async (payload: IQueryParamReport, { rejectWithValue }) => {
    try {
      const resp = await reportApi.getAverageJob(payload);
      return resp?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportPurchaseOderTotal = createAsyncThunk(
  GET_REPORT_PURCHASE_ORDER_TOTAL,
  async (payload: IQueryParamReport, { rejectWithValue }) => {
    try {
      const resp = await reportApi.getPurchaseOderTotal(payload);
      return resp?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportSaleByCity = createAsyncThunk(
  GET_REPORT_SALE_BY_CITY,
  async (payload: IQueryParamReport, { rejectWithValue }) => {
    try {
      const resp = await reportApi.getSaleByCity(payload);
      return resp?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getReportJobDistribution = createAsyncThunk<IJobDistributionItemRes[], IQueryParamReport>(
  GET_REPORT_JOB_DISTRIBUTION,
  async (payload: IQueryParamReport, { rejectWithValue }) => {
    try {
      const resp = await reportApi.getJobDistribution(payload);
      return resp?.data?.data ?? [];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
